import React from "react"
import { graphql, Link } from "gatsby"

import { Description } from "components"
import AltmetricBadge from "./altmetric-badge"
import LinksAndPdfs from "./links-and-pdfs"

export default function Resource({
  title,
  slug,
  description,
  cover,
  pdfs,
  links,
  doi
}: Queries.ResourceFragment) {
  return (
    <div className="grid gap-x-6 gap-y-4 md:grid-cols-4">
      <div>
        {cover && (
          <Link to={`/resources/${slug}`}>
            <img
              className="max-h-[75vw] max-w-full md:max-h-none"
              src={cover.file.url}
              alt={`${title} cover`}
            />
          </Link>
        )}
      </div>

      <div className="md:col-span-3">
        <AltmetricBadge doi={doi} />

        <h3>
          <Link to={`/resources/${slug}`}>{title}</Link>
        </h3>
        {description && <Description description={description} />}

        <LinksAndPdfs links={links} pdfs={pdfs} />
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment Resource on ContentfulResource {
    contentful_id
    title
    slug
    description {
      raw
    }
    cover {
      file {
        url
      }
    }
    ...LinksAndPdfs
    ...Doi
    metaImage {
      file {
        url
      }
    }
  }
`
